import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import NegotiationModalContainer from '../../Modal/NegotiationModalContainer';
import UserService from '../../../services/UserService';
import MixpanelConfig from '../../../_shared/constants/mixpanelConfig';
import { BidSource } from '../../../_shared/types/auction';
import ROUTES from '../../Routes/constants';
import useAnalytics, {
  getSellerProperties,
  getVinBasicProperties
} from '../../../_shared/hooks/useAnalytics';
import SegmentConfig from '../../../_shared/constants/segmentConfig';

const ViewNegotiationContainer = ({
  trade,
  Button,
  tradeContext,
  isOmp = false
}) => {
  const track = useAnalytics();
  const [negotiationModalIsOpen, setNegotiationModalIsOpen] = useState(false);
  const eventSource = window.location.href.includes(ROUTES.TRADE_URI)
    ? BidSource.VDP_OVERLAY
    : BidSource.LIST_VIEW;
  const userService = UserService.get();
  const user = useSelector(state => state?.auth?.user, shallowEqual);

  const onViewNegotiationModal = () => {
    setNegotiationModalIsOpen(true);

    track(SegmentConfig.names.pendingViewButtonClicked, {
      ...getVinBasicProperties(trade),
      ...getSellerProperties(trade),
      event_state_type: userService.isSeller(user, trade?.dealer?.id)
        ? SegmentConfig.eventStateType.sellPending
        : SegmentConfig.eventStateType.buyPending
    });
    track(MixpanelConfig.names.viewNegotiationHistory, {
      user_type: userService.isSeller(user, trade?.dealer?.id)
        ? MixpanelConfig.userType.seller
        : MixpanelConfig.userType.buyer, // TODO: Add 2nd bidder. May not have a way to tell if it's the second bidder
      source: eventSource,
      trade_id: trade?.id,
      auction_id: trade?.auctionId
    });
  };

  const onCloseNegotiationModal = () => {
    setNegotiationModalIsOpen(false);
  };

  return (
    <>
      <Button onClick={onViewNegotiationModal} />
      <NegotiationModalContainer
        trade={trade}
        tradeContext={tradeContext}
        modalIsOpen={negotiationModalIsOpen}
        onClose={onCloseNegotiationModal}
        isOmp={isOmp}
      />
    </>
  );
};

export default ViewNegotiationContainer;
